import apiClient from './api';

export interface WhatsNewActiveItem {
  id: string;
  title: string;
  version_label: string | null;
  bullets: string[];
  published_at: string | null;
}

class WhatsNewService {
  /** Latest published What's New the current user has not dismissed (null if none). */
  async getActive(): Promise<WhatsNewActiveItem | null> {
    const { data } = await apiClient.get<WhatsNewActiveItem | null>('/whats-new/active');
    return data ?? null;
  }

  async dismiss(id: string): Promise<void> {
    await apiClient.post(`/whats-new/${encodeURIComponent(id)}/dismiss`);
  }
}

export default new WhatsNewService();
